<template>
  <div ref="layout" v-loading="loading" class="page-form">
    <h3 class="title">经销商分流关系设置</h3>

    <div class="form-container">
      <errors-list :errors="errorList" />
      <div class="tools">
        <form-button name="提交" icon="form-advance" @click="saveData" />
      </div>
      <el-form ref="form" :show-message="false" inline size="mini" label-width="100px" :model="conditions" :rules="rules">
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="创建人">
              <el-input v-model="conditions.createdByName" disabled />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="创建日期">
              <el-date-picker
                v-model="conditions.createdDate"
                type="date"
                value-format="yyyy-MM-dd"
                disabled
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="所属中心">
              <el-input v-model="conditions.saleCenterName" disabled />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="经销商" prop="customerName">
              <wly-input
                v-model="conditions.customerName"
                input-type="customer"
                @enter="handleEnter"
                @handleSuffixClick="openDialog"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div class="table-container">
      <TableCommon title="分流客户" :custome-config="() => vxeShowCustom('xTable')">
        <template #button>
          <table-button name="add" tip="新增" @click="addRow" />
          <table-button name="delete" tip="删除" @click="deleteRow" />
        </template>
        <vxe-grid
          ref="xTable"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="300"
          max-height="500"
          align="center"
          size="mini"
          :checkbox-config="{ highlight: true }"
          :radio-config="{ highlight: true }"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptions.columns"
          :data="gridOptions.data"
        >
          <template #shuntingCustomerName="{ row }">
            <wly-input
              v-model="row.shuntingCustomerName"
              input-type="customer"
              @enter="handleEnter(...arguments, row)"
              @handleSuffixClick="openDialog($event, row)"
            />
          </template>
          <template #startup="{ row }">
            <el-checkbox v-model="row.startup" :true-label="1" :false-label="0">是</el-checkbox>
          </template>
          <template #channels="{ row }">
            <el-select v-model="row.channels" size="mini">
              <el-option
                v-for="item in selectDataOptions['A0054']"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              />
            </el-select>
          </template>
          <template #remark="{ row }">
            <el-input v-model="row.remark" />
          </template>
        </vxe-grid>
      </TableCommon>

      <TableCommon title="附件" :custome-config="() => vxeShowCustom('xTable3')">
        <template #button>
          <el-upload
            ref="upload"
            action=""
            :on-change="uploadFile"
            :show-file-list="false"
            :auto-upload="false"
          >
            <table-button slot="trigger" name="upload" tip="上传" />
          </el-upload>
          <table-button name="delete" tip="删除" @click="delUpload" />
        </template>
        <vxe-grid
          ref="xTable3"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="300"
          align="center"
          size="mini"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptions2.columns"
          :data="gridOptions2.data"
        >
          <template #fileName="{row}">
            <span class="blue" @click="dowLoadFile(row)">{{ row.fileName }}</span>
          </template>
          <template #createdDate="{row}">
            <span>{{ row.createdDate || row.creator.createdDate }}</span>
          </template>
        </vxe-grid>
      </TableCommon>
    </div>

    <el-dialog v-dialogDrag :visible.sync="showDialog" title="客户选择" width="70%">
      <template v-if="showDialog">
        <client-select ref="dialogSelect" />
      </template>
      <div slot="footer">
        <el-button size="small" type="primary" @click="showDialog = false">取消</el-button>
        <el-button size="small" type="primary" @click="submitHandle">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { webUploadFile, queryFiles, apiAttachmentDownFile } from '@/api/common'
import ClientSelect from '@/components/dialog/ClientSelect.vue'
import { apiLoadDictionaryDtl } from '@/api/platform/dictionary/index'
import { setShuntingAdd, apiFindDealers } from '@/api/applyForGoods/index'
import { download } from '@/utils/frontExport'
export default {
  name: 'DealersDiversion',
  components: {
    ClientSelect
  },

  data() {
    const rules = {
      customerName: [{ required: true, message: '请选择经销商', trigger: 'change' }]
    }
    return {
      rules,
      loading: false,
      processKey: 'shunting',
      showDialog: false,
      currentRow: undefined,
      selectDataOptions: {},
      bizId: '',
      errorList: [],
      conditions: {
        createdById: '',
        createdByName: '',
        createdDate: '',
        customerName: '',
        customer: '',
        saleCenter: '',
        saleCenterName: ''
      },
      gridOptions: {
        columns: [
          { type: 'checkbox', title: '', field: 'checkbox', width: 50 },
          {
            title: '分流经销商',
            field: 'shuntingCustomerName',
            slots: { default: 'shuntingCustomerName' }
          },
          { title: '是否启用', field: 'startup', slots: { default: 'startup' }},
          { title: '分流渠道类型', field: 'channels', slots: { default: 'channels' }},
          { title: '备注', field: 'remark', slots: { default: 'remark' }},
          { title: '分流ID', field: 'shuntingId', width: 50, visible: false }
        ],
        data: []
      },
      gridOptions2: {
        columns: [
          { type: 'checkbox', title: '', filed: 'checkbox', width: 50 },
          {
            field: 'fileName',
            title: '附件名称',
            slots: { default: 'fileName' }
          },
          {
            field: 'fileKind',
            title: '附件类型'
          },
          {
            field: 'fileSize',
            title: '大小'
          },
          {
            field: 'createdDate',
            title: '上传时间',
            slots: { default: 'createdDate' }
          }
        ],
        data: []
      },
      fileDetail: {
        id: '',
        fileName: ''
      }
    }
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  created() {
    this.getSelectDictDataOrigin('A0054')
    this.conditions.createdByName = this.userInfo.loginUser.name
    this.conditions.saleCenterName = this.userInfo.deptName
    this.conditions.createdDate = this.$utilsCommon.parseTime(new Date().getTime(), '{y}-{m}-{d}')
  },

  methods: {
    saveData() {
      this.validate()
    },
    validate() {
      this.errorList = []
      this.$refs.form.validate(async(val, err) => {
        if (val) {
          this.loading = true
          const params = {
            ...this.conditions,
            setShuntingDetailList: this.gridOptions.data
          }
          try {
            const { status } = await setShuntingAdd(params)
            if (status === 1) {
              this.$message.success('提交成功')
            }
          } catch (e) {
            //
          }
          this.loading = false
        } else {
          this.errorList = this.$utilsCommon.filterErrorMsg(err)
          return false
        }
      })
    },
    addRow() {
      const row = {
        shuntingCustomerName: '',
        startup: '0',
        channels: '',
        remark: ''
      }
      this.gridOptions.data.unshift(row)
    },
    openDialog(e, row = undefined) {
      e.target.blur()
      this.currentRow = row
      this.showDialog = true
    },
    // 控件回车
    async handleEnter(e, type, data, row) {
      // console.log('handleEnter', type, data)
      if (typeof type === 'object') {
        this.errorList ? (this.errorList = [type.message]) : this.$message.error(type.message)
        return
      }
      if (!data) return

      if (row) {
        // 分流经销商
        this.currentRow = row
        this.currentRow.shuntingCustomerName = data.customerName
        this.currentRow.shuntingCustomer = data.customerCode
      } else {
        // 经销商
        this.conditions.customer = data.customerCode
        this.conditions.customerName = data.customerName
      }
    },
    async submitHandle() {
      const data = await this.$refs.dialogSelect.submitForm()
      if (data) {
        if (this.currentRow) {
          // 分流经销商
          this.currentRow.shuntingCustomerName = data.customerName
          this.currentRow.shuntingCustomer = data.customerCode
        } else {
          // 经销商
          this.conditions.customer = data.customerCode
          this.conditions.customerName = data.customerName

          const params = {
            customerCode: data.customerCode
          }
          const respone = await apiFindDealers(params)
          this.gridOptions.data = respone.data
          this.bizId = respone.data ? this.gridOptions.data[0].shuntingId : ''
          this.getFiles()
        }
      }

      this.showDialog = false
    },

    deleteRow() {
      const data = this.$refs.xTable.getCheckboxRecords()
      if (data) {
        data.forEach(item => {
          const index = this.gridOptions.data.findIndex(v => v._X_ID === item._X_ID)
          this.gridOptions.data.splice(index, 1)
        })
      }
    },
    async dowLoadFile({ file_id, id, fileName }) {
      const res = await apiAttachmentDownFile({ id: file_id || id })
      download(res.data, fileName)
    },
    async getFiles() {
      const params = {
        bizId: this.bizId,
        bizCode: this.processKey
      }
      const { data } = await queryFiles(params)
      this.gridOptions2.data = data
    },
    async uploadFile(file) {
      const formData = new FormData()
      //formData.append('bizId', 789456)
     //formData.append('bizCode', 55552)
      formData.append('bizId', this.bizId)
      formData.append('bizCode', this.processKey)
      formData.append('formSecretLevel', 0)
      formData.append('name', file.name)
      formData.append('type', file.raw.type)
      formData.append('lastModifiedDate', file.raw.lastModifiedDate)
      formData.append('size', file.size)
      formData.append('file', file.raw)
      const { data } = await webUploadFile(formData)
      data.file_id = data.id
      delete data.id
      this.gridOptions2.data.unshift(data)
    },
    // 删除附件
    delUpload() {
      const checkedList = this.$refs.xTable3.getCheckboxRecords()
      checkedList.forEach(item => {
        const index = this.gridOptions2.data.findIndex(v => v._X_ID === item._X_ID)
        this.gridOptions2.data.splice(index, 1)
      })
    },
    getSelectDictDataOrigin(dictcode) {
      const formData = new FormData()
      // alert(dictcode)
      formData.append('code', dictcode)
      apiLoadDictionaryDtl(formData)
        .then(response => {
          this.$set(this.selectDataOptions, dictcode, response.data.Rows)
        })
        .catch(() => {})
    }
  }
}
</script>

<style scoped>
/* .page-form .form-container .el-form .el-form-item.el-form-item--mini{
  margin-bottom: 15px;
} */
</style>



// WEBPACK FOOTER //
// src/views/apply-for-manage/base-setting/dealersDiversion.vue